// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"629506b5","358":"a1368e01","404":"2fd1372e","916":"0779c6ab"}[chunkId] + ".chunk.js";
};